import { LoggerService } from 'src/app/services/logger.service';
import { UserApiService } from '../../services/user-api.service';
import { ApiRequestModel } from 'src/app/models/api-request-model';
import { MonthViewModel, PersianDateViewModel } from 'src/app/models/calender-models/calender-model';
import { Component, ElementRef, ViewChild } from '@angular/core';
import { CalendarService } from 'src/app/services/calender-service';
import { Field } from '../../models/entity-defin';
import { NgbModal, NgbPopover } from '@ng-bootstrap/ng-bootstrap';
import { PCTableInputModel,PCTableOutputModel, } from '../../models/pc-table-input-model';

@Component({
  selector: 'app-calender',
  templateUrl: './calender.component.html',
  styleUrls: ['./calender.component.css'],
})


export class CalenderComponent {
  public thisMonth: MonthViewModel = new MonthViewModel(1);
  public thisMonthNumber: number = 0;
  public thisYearNumber: number = 0;
  public backEndJson: any = { name: '', description: '', date: '' };
  public loading: boolean = false;
  public thisNewMonth: any;
  public apiResponse: any;
  public monthName: string = '';
  public modalIsOpen: boolean = false;
  public modalLoading: boolean = false;
  public modalSuccessConfirm: boolean = false;
  public checkFilter: boolean = true;
  public eventFilter: boolean = true;
  public factorFilter: boolean = true;
  public selectedDate!: PersianDateViewModel;
  public data?: PCTableInputModel;
  public modalDeleteConfirm: boolean = false;
  public deleteValue: any ;

  public sumOfCheck: number = 0;
  public sumOfFactor: number = 0;
  public countOfEvent: number = 0;


  @ViewChild('datePicker') public popoverDataPicker!: NgbPopover;
  @ViewChild('newEventModal') public newEventModalElement!: ElementRef;
  @ViewChild('viewDetailModal') public viewDetailModalElement!: ElementRef;

  constructor(
    private logger: LoggerService,
    private apiService: UserApiService,
    private modalService: NgbModal,
    private calendarService: CalendarService
  ) {
    this.setMonth();
  }

  public setOnMonth() {

    this.thisMonth.weeks = this.calendarService.GetMonth(
      this.thisMonthNumber,
      this.thisYearNumber
    );

    this.countOfEvent = 0;
    this.sumOfFactor = 0;
    this.sumOfCheck = 0;

    var monthIsStart = false;
    for (let index = 0; index < this.thisMonth.weeks.length; index++) {
      const elementWeek = this.thisMonth.weeks[index];
      for (
        let secondIndex = 0;
        secondIndex < elementWeek.days.length;
        secondIndex++
      ) {
        const elementDay = elementWeek.days[secondIndex];

        if (elementDay.day == 1) {
          monthIsStart = true;
        }

        const dayString = `${elementDay.dateTime.getFullYear()}-${(elementDay.dateTime.getMonth() + 1).toString().padStart(2, '0')}-${(elementDay.dateTime.getDate()).toString().padStart(2, '0')}T00:00:00`
        if (this.eventFilter == true) {
          elementDay.events = this.apiResponse.events.filter(
            (current) => current.date == dayString
          );

          this.countOfEvent += elementDay.events.length;
        }

        if (this.checkFilter == true) {
          elementDay.checks = this.apiResponse.checks.filter(
            (current) => current.date == dayString
          );

          for (let index = 0; index < elementDay.checks.length; index++) {
            const element = elementDay.checks[index];
            const thisCheckPrice: number = + element.name;
            this.sumOfCheck += thisCheckPrice;
          }
        }
        if (this.factorFilter == true) {
          elementDay.factors = this.apiResponse.factors.filter(
            (current) => current.date == dayString
          );

          for (let index = 0; index < elementDay.factors.length; index++) {
            const element = elementDay.factors[index];

            this.sumOfFactor += element.name;
          }
        }
      }
    }
  }

  public previousMonth() {
    if (this.thisMonthNumber == 1) {
      this.thisYearNumber--;
      this.thisMonthNumber = 12;
      this.setMonth();
    } else {
      this.thisMonthNumber--;
      this.setMonth();
    }
  }

  public nextMonth() {
    if (this.thisMonthNumber == 12) {
      this.thisYearNumber++;
      this.thisMonthNumber = 1;
      this.setMonth();
    } else {
      this.thisMonthNumber++;
      this.setMonth();
    }
  }

  public nextYear() {
    this.thisYearNumber++;
    this.setMonth();
  }

  public previousYear() {
    this.thisYearNumber--;
    this.setMonth();
  }

  public setMonth() {
    if (this.thisMonthNumber != 0 || this.thisYearNumber != 0) {
      const thisStartDay = this.calendarService.ToGregorianDateTime(`${this.thisYearNumber}/${this.thisMonthNumber}/1`);
      this.getCalenderData(`${thisStartDay.getFullYear()}-${(thisStartDay.getMonth() + 1).toString().padStart(2, '0')}-${thisStartDay.getDate().toString().padStart(2, '0')}T00:00:00`);
    } else {
      const today = new Date();
      const firstMonthDayPersian = this.calendarService.ToPersianDateTime(`${today.getFullYear()}/${today.getMonth()+1}/${today.getDate().toString().padStart(2, '0')}`);
      this.thisYearNumber = firstMonthDayPersian.year;
      this.thisMonthNumber = firstMonthDayPersian.month;

      this.getCalenderData();
    }
  }

  public getCalenderData(date?: string) {
    try {
      // this.loading = true;
      // let url;
      // if (date != null) {
      //   url = `Calender/GetMonth?startDate=${date}`;
      // } else {
      //   const firstDayOfThisMonthGregorian = this.calendarService.ToGregorianDateTime(
      //     `${this.thisYearNumber}/${this.thisMonthNumber}/01`
      //   );
      //   const backEndFormat = `${firstDayOfThisMonthGregorian.getFullYear()}-${(firstDayOfThisMonthGregorian.getMonth() + 1).toString().padStart(2, '0')}-${firstDayOfThisMonthGregorian.getDate().toString().padStart(2, '0')}T00:00:00.00`
      //   url = `Calender/GetMonth?startDate=${backEndFormat}`;
      // }
      // if (!this.apiService.tokenValidation(new ApiRequestModel(url))) {
      //   return;
      // }
      // this.apiService.getSingleItem(new ApiRequestModel(url)).subscribe(
      //   (result) => {
      //     this.logger.addResponseLog(url, result, `Get All`);
      //     if (result.succeeded) {
      //       this.apiResponse = result.data;
      //       if (this.thisMonthNumber == 0 || this.thisYearNumber == 0) {
      //         const today = this.calendarService.ToPersianDateTime(new Date().toString());
      //         this.thisMonthNumber = today.month;
      //         this.thisYearNumber = today.year;
      //       }
      //       this.setOnMonth();
      //     }else{
      //       this.logger.addBackEndMessage(result);
      //     }
      //     this.loading = false;
      //   },
      //   (error) => {
      //     this.apiService.AddErrorLog(error);
      //     this.loading = false;
      //   },
      //   () => {
      //     this.loading = false;
      //   }
      // );
    } catch (e) {
      this.logger.addException(e, true);
      this.loading = false;
    }
  }

  public pad(num: number, size: number): string {
    let s = num + '';
    while (s.length < size) s = '0' + s;
    return s;
  }
  
  public changeMonth(val: string) {
    if (this.popoverDataPicker.isOpen()) {
      this.popoverDataPicker.close();
    }
    this.monthName = val;
  }

  public openModal(content: any) {
    try {
      this.modalService
        .open(content, { ariaLabelledBy: 'modal-basic-title', size: 'm' })
        .result.then(
          (result) => {
            if (result == 'Save click') {
            }
            setTimeout(() => {
              this.modalIsOpen = false;
            }, 1 * 1000);
          },
          (reason) => {
            setTimeout(() => {
              this.modalIsOpen = false;
            }, 1 * 1000);
          }
        );
    } catch (error) { }
  }

  public createNewEvent(item: PersianDateViewModel) {
    this.selectedDate = item;
    this.backEndJson.date = `${item.dateTime.getFullYear()}-${(item.dateTime.getMonth() + 1).toString().padStart(2, '0')}-${item.dateTime.getDate().toString().padStart(2, '0')}T00:00:00.00`
    if (this.modalIsOpen == false) {
      this.openModal(this.newEventModalElement);
      this.modalIsOpen = true;
      setTimeout(() => {
        var newEventModal = document.getElementById('newEventModal');
        newEventModal?.focus();
      }, 1 * 1000);
    }
  }

  public submitModal() {
    try {
      this.modalLoading = true;

      let url = `Calender`;

      if (!this.apiService.tokenValidation(new ApiRequestModel(url))) {
        this.modalLoading = false;
        return;
      }
      this.apiService.postItem(new ApiRequestModel(url, this.backEndJson))
        .subscribe(
          result => {
            if (result.succeeded) {
              this.modalSuccessConfirm = true;
              this.countOfEvent++;
              this.modalService.dismissAll();
              this.backEndJson = { name: '', description: '', date: '' };
              if (this.selectedDate != null) {
                let newItem = {
                  description: result.data.description,
                  name: result.data.name,
                  date: result.data.date,
                  id: ""
                }
                this.selectedDate.events.push(newItem);
              }
            }
            else {
              for (let error of result.errorMessages) {
                this.logger.addError(error, false);
              }
            }
            this.modalLoading = false;
          },

          error => {
            this.apiService.AddErrorLog(error);
            this.modalLoading = false;
          },
          () => {
            this.modalLoading = false;
          }
        );
    } catch (e) {
      this.logger.addException(e, true);
      this.modalLoading = false;
    }
  }

  public showDetailModal(item: any) {
    try {
      this.data = new PCTableInputModel(
        item.events,
        [
          {
            name: 'Delete',
            className: 'btn-outline-danger',
            icon: 'bx bx-trash',
          }
        ],
        true,
        1
      );
      this.selectedDate = item;
      this.openModal(this.viewDetailModalElement);
    } catch (e) {
      this.logger.addException(e, true);
    }
  }

  public submitDelete() {
    try {
      this.modalLoading = true;
      this.modalDeleteConfirm = false;
      let url = `Calender/${this.deleteValue.id}`;
      this.apiService.deleteItem(new ApiRequestModel(url)).subscribe(
        (result) => {
          this.logger.addResponseLog(url, result, `Delete`);
          if (result.succeeded) {
            const index:number=this.selectedDate.events.indexOf(this.deleteValue.id);
            this.selectedDate.events.splice(index);
            
            this.modalSuccessConfirm = true;
          }
          else {
            this.logger.addBackEndMessage(result);
          }
          this.modalLoading = false;
        },
        (error) => {
          this.apiService.AddErrorLog(error);
          this.modalLoading = false;
        },
        () => { }
      );
    } catch (e) {
      this.logger.addException(e, false);
      this.modalLoading = false;
    }
  }

  public NotDelete(){
    this.modalDeleteConfirm = false;
    this.deleteValue = undefined;
  }


  public parentAction(event : PCTableOutputModel) {
    switch (event.action) {
      case "Successed":
        this.modalSuccessConfirm = false;
        break;
      case 'Delete':
        this.modalDeleteConfirm = true;
        this.deleteValue = event.data;
        break;
      default:
        break;
    }
  }



}
